const CHUNK_RELOAD_KEY = 'sh_chunk_reload_at';
const CHUNK_RELOAD_COOLDOWN_MS = 15_000;

export function isChunkLoadError(error) {
  if (!error) return false;

  const name = error.name || '';
  const message = error.message || String(error);

  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /error loading dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Unable to preload CSS/i.test(message)
  );
}

/**
 * Reloads once per cooldown window so a stale deploy can recover
 * without looping if the failure is permanent.
 * @returns {boolean} true if a reload was triggered
 */
export function tryReloadForChunkError() {
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    const now = Date.now();
    if (last && now - last < CHUNK_RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  } catch {
    // sessionStorage unavailable — still attempt one reload
  }
  window.location.reload();
  return true;
}
